import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { DisplayNameField } from '@anm/components/form/fields';
import { UserFormRow } from '@anm/styles/helpers';
import styled from 'styled-components';

export const WrapperTeamForm = styled.form``;

export const ButtonLoaderWrapper = styled(ButtonLoader)`
  margin-top: 20px;
`;
export const TeamName = styled(DisplayNameField)`
  margin-top: 15px;

  width: 360px;
`;

export const RightSide = styled.div`
  display: flex;
  > *:first-child {
    margin-right: 20px;
  }
`;
export const TeamFormSection = styled.div`
  margin: 36px 0 0;
  max-width: 100%;
  &:first-of-type {
    margin-top: 3px;
  }
  ${UserFormRow} {
    margin-top: 30px;
    align-items: flex-start;
  }
`;
